import { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';

import { getCredentials, isTokenExpired } from './lib/api';
import { useComponentDidMount } from './modules/core/hooks';
import * as authActions from './modules/auth/store/actions';
import LoginHomePage from './modules/auth/LoginHomePage';
import TokenExpiredModal from './modules/auth/TokenExpiredModal';
import { listenPush } from './modules/notifications/push';
import WorkShiftInfoPanel from './components/navigation/WorkShiftInfoPanel';
import { SideBar, ProfileMenu } from './components/navigation';
import { Footer } from './components/footer';
import { useMedia } from 'react-use';

// interface AppProps {
//   user?: object
//   children?: object
//   getProfile?(...args: unknown[]): unknown
// }

const App = props => {
  const { user, getProfile } = props;

  const isTabMobile = useMedia('(max-width: 991px)');

  useComponentDidMount(() => {
    const { token } = getCredentials();

    if (!isTokenExpired(token)) {
      getProfile({ token });
    }
  });

  useEffect(() => {
    if (user.customerId) {
      listenPush(user.customerId);
    }
  }, [user.customerId]);

  if (!user?.token) return (props.children);

  return isTokenExpired(user?.token)
    ? (<LoginHomePage />)
    : (
      <div className='wrapper'>
        <SideBar />

        <main className='page-container'>
          <nav className='navbar navbar-static-top'>
            { !isTabMobile && <WorkShiftInfoPanel /> }
            <ProfileMenu />
          </nav>

          <Container fluid>
            <Row className='page-content'>
              <Col lg={ 12 }>
                { props.children }
              </Col>
            </Row>
          </Container>
        </main>

        <Footer />

        <TokenExpiredModal token={ user?.token } />

        <ReduxToastr
          timeOut={ 4000 }
          newestOnTop={ false }
          preventDuplicates
          position='top-right'
          transitionIn='fadeIn'
          transitionOut='fadeOut'
          progressBar
          closeOnToastrClick
        />
      </div>
    );
};

const mapStateToProps = state => ({
  user: state.auth?.profile,
});

const mapDispatchToProps = dispatch => ({
  getProfile: payload => dispatch(authActions.getProfile(payload)),
});

const connected = connect(mapStateToProps, mapDispatchToProps)(App);

export default connected;